
import DocumentNormal from "../../../assets/duotone/DocumentNormal.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DocumentNormalIcon({ className, dataTestid = "DocumentNormalIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <DocumentNormal data-testid={dataTestid} className={classes} {...rest} />
  );
}
